module.exports = __webpack_public_path__ + "img/Samantha.74a6d912.jpg";